/* DateTimePickerPopupRenderer.js */

"use strict";
const _ = require("lodash");
/* global $ */

// console.log($("#div").kendoDateTimePicker);

const ButtonControl = require("@gluenetworks/button_control");
const BaseSubComponentScheduleRenderer = require("../../base/BaseSubComponentScheduleRenderer");
const RendererUtils = require("../../base/RendererUtils");

class DateTimePickerPopupRenderer extends BaseSubComponentScheduleRenderer {
    constructor(model, schedulePropName) {
        super(model, "date-time-picker-popup-gl");
        this._schedulePropName = schedulePropName;
        this._pickerType = "";
    }
    render() {
        if (this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._dateLabelElem = document.createElement("value-label-gl");
                this._popupElem = document.createElement("popup-gl");
                let cond = this._model.getDateTimeCondition(this._schedulePropName);
                // let config = {
                //     showDate: _.get(cond, 'includeDate'),
                //     showTime: _.get(cond, 'includeTime')
                // };
                this._showDate = _.get(cond, "includeDate");
                this._showTime = _.get(cond, "includeTime");
                /*
                    $("#datetime").kendoDateTimePicker();
                */
                // this._dateTimePickerComp = new DateTimePicker(config);
                this._dateTimePickerComp = document.createElement("input");
                this._pickerId =
                    "schDtTimePicker" + new Date().getTime() + parseInt(Math.random() * 100, 10);
                this._dateTimePickerComp.setAttribute("id", this._pickerId);
                // this._dateTimePickerComp.classList.add("picker-light");
                // this._popupElem.appendChild(this._dateTimePickerComp.renderer.rootElement);
                // RendererUtils.hideElements(this._popupElem);
                this._okCancelElem = document.createElement("ok-cancel-gl");
                this._dateOkButtonComp = new ButtonControl({label: "\u2714"});
                this._okCancelElem.appendChild(this._dateOkButtonComp.renderer.rootElement);
                this._dateCancelButtonComp = new ButtonControl({label: "\u2718"});
                this._okCancelElem.appendChild(this._dateCancelButtonComp.renderer.rootElement);
                // this._rootElem.appendChild(this._dateLabelElem);
                this._rootElem.appendChild(this._dateTimePickerComp);
                this._popupElem.appendChild(this._okCancelElem);
                // return this._dateTimePickerComp.renderer.render();
                this._checkExist = setInterval(() => {
                    if ($("#" + this._pickerId).length > 0) {
                        // console.log("Exists!");
                        this.renderPicker();
                        clearInterval(this._checkExist);
                    }
                }, 25);
                return Promise.resolve();
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    renderPicker() {
        // console.log("render");
        const self = this;
        if (self._pickerControl) {
            self._pickerControl.destroy();
        }
        self._pickerControl = undefined;
        if ($("#" + this._pickerId).length <= 0) {
            return Promise.resolve();
        }
        if (this._showDate && this._showTime) {
            $("#" + this._pickerId).kendoDateTimePicker({
                componentType: "modern",
                footer: false,
                value: self._model.getDateTime(this._schedulePropName) || new Date(),
                format: "dddd, MMMM dd, yyyy, hh:mm tt zzz",
                open: function () {
                    let calendar = $("div.k-calendar").data("kendoCalendar");
                    calendar.bind("change", function (/* evt */) {
                        // console.log("change", evt);
                    });
                    // console.log(this);
                    self._pickerControl = this;
                },
                change: function () {
                    let value = this.value();
                    self._pickerControl.timeView._currentlySelected = value;
                    self._onDateOk(value);
                },
                close: function (/* evt */) {
                    // console.log(this);
                    // console.log(self._pickerControl.value());
                    self._onDateOk(self._pickerControl.timeView._currentlySelected);
                },
            });
            this._pickerType = "kendoDateTimePicker";
        } else if (this._showDate) {
            $("#" + this._pickerId).kendoDatePicker({
                value: self._model.getDateTime(this._schedulePropName) || new Date(),
                format: "dddd, MMMM dd, yyyy",
                change: function () {
                    // console.log(this.value());
                    self._onDateOk(this.value());
                },
            });
            this._pickerType = "kendoDatePicker";
        } else if (this._showTime) {
            $("#" + this._pickerId).kendoTimePicker({
                componentType: "modern",
                value: self._model.getDateTime(this._schedulePropName) || new Date(),
                open: function () {
                    self._pickerControl = this;
                },
                close: function (/* evt */) {
                    // console.log(this);
                    // console.log(self._pickerControl.value());
                    self._onDateOk(self._pickerControl.timeView._currentlySelected);
                },
            });
            this._pickerType = "kendoTimePicker";
        }

        this._pickerControl = $("#" + this._pickerId).data(this._pickerType);
        if (
            this._dateTimePickerComp.classList.contains("dark") ||
            this._dateTimePickerComp.classList.contains("veil")
        ) {
            switch (this._pickerType) {
                case "kendoDateTimePicker":
                    this._pickerControl.popup.element[0].classList.add("dark");
                    // this._pickerControl.popup.element[0].parentElement.classList.add("dark");
                    break;

                case "kendoDatePicker":
                    this._pickerControl.dateView.popup.element[0].classList.add("dark");
                    // this._pickerControl.dateView.popup.element[0].parentElement.classList.add("dark");
                    break;
                case "kendoTimePicker":
                    this._pickerControl.timeView.popup.element[0].classList.add("dark");
                    // this._pickerControl.timeView.popup.element[0].parentElement.classList.add("dark");
                    break;
            }
        } else {
            switch (this._pickerType) {
                case "kendoDateTimePicker":
                    this._pickerControl.popup.element[0].classList.remove("dark");
                    // this._pickerControl.popup.element[0].parentElement.classList.remove("dark");
                    break;

                case "kendoDatePicker":
                    this._pickerControl.dateView.popup.element[0].classList.remove("dark");
                    // this._pickerControl.dateView.popup.element[0].parentElement.classList.remove("dark");
                    break;
                case "kendoTimePicker":
                    this._pickerControl.timeView.popup.element[0].classList.remove("dark");
                    // this._pickerControl.timeView.popup.element[0].parentElement.classList.remove("dark");
                    break;
            }
        }
    }
    getParts() {
        return [
            this._dateLabelElem,
            this._dateTimePickerComp,
            this._dateOkButtonComp,
            this._dateCancelButtonComp,
        ];
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                if (this._pickerControl) {
                    this._pickerControl.destroy();
                }
                return Promise.all([
                    super.shutdown(),
                    // this._dateTimePickerComp.shutdown(),
                    this._dateOkButtonComp.shutdown(),
                ]);
            })
            .then(() => {
                this._popupElem.remove();
                this._popupElem = undefined;
                this._dateLabelElem = undefined;
                this._dateTimePickerComp = undefined;
                this._dateOkButtonComp = undefined;
                this._okCancelElem.remove();
                this._okCancelElem = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        super._registerListeners();
        // this._dateLabelElem.addEventListener('click', this._onDateLabelClick = this._onDateLabelClick.bind(this));
        this._dateOkButtonComp.on("UserClick", (this._onDateOk = this._onDateOk.bind(this)));
        this._dateCancelButtonComp.on(
            "UserClick",
            (this._onDateCancel = this._onDateCancel.bind(this))
        );
        this._popupElem.addEventListener(
            "click",
            (this._onPopupClick = this._onPopupClick.bind(this))
        );
    }
    _unregisterListeners() {
        super._unregisterListeners();
        // this._dateLabelElem.removeEventListener('click', this._onDateLabelClick);
        this._dateOkButtonComp.removeListener("UserClick", this._onDateOk);
        this._dateCancelButtonComp.removeListener("UserClick", this._onDateCancel);
    }
    _onDateLabelClick(event) {
        event.stopImmediatePropagation();
        this._dateTimePickerComp.setValue(this._model.getScheduleProp(this._schedulePropName));
        RendererUtils.showElements(this._popupElem);
        document.addEventListener("click", (this._onBodyClick = this._onBodyClick.bind(this)));
    }
    _onDateOk(val) {
        const _picker = $("#" + this._pickerId).data(this._pickerType);
        _picker.value(val);
        // const date = this._model.getDateTime(this._schedulePropName);
        // console.log(date);
        this._model.setDateTimeValue(this._schedulePropName, val, true);
    }
    _onDateCancel() {
        RendererUtils.hideElements(this._popupElem);
        document.removeEventListener("click", this._onBodyClick);
    }
    _onPopupClick(event) {
        event.stopImmediatePropagation();
    }
    _onBodyClick() {
        // RendererUtils.hideElements(this._popupElem);
        this._onDateOk();
        // document.removeEventListener('click', this._onBodyClick);
    }
    _setControlValuesFromModel() {
        // console.log("value");
        // this._dateLabelElem.innerText = this._model.getDateTimeString(this._schedulePropName);
        const _picker = $("#" + this._pickerId).data(this._pickerType);
        if (_picker) {
            _picker.value(this._model.getDateTime(this._schedulePropName));
        }
    }
}
module.exports = DateTimePickerPopupRenderer;
